module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/logos/logo-lwp-3c8a37c156eb955e9cb95e2374d90ab7.svg";